import { createSlice } from "@reduxjs/toolkit";
import { searchPharmacyMedicines } from "../../reducer/searchPharmacyMedicines/searchPharmacyMedicinesReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const searchPharmacyMedicinesSlice = createSlice({
  name: "searchPharmacyMedicines",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(searchPharmacyMedicines.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(searchPharmacyMedicines.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(searchPharmacyMedicines.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default searchPharmacyMedicinesSlice.reducer;
